var map = {
	"./4everland.svg": "4e0f",
	"./4everland_normal.svg": "8842",
	"./carv.svg": "2b50",
	"./carv_hoverd.svg": "0e4d",
	"./legal_now.svg": "f83d",
	"./legal_now_normal.svg": "c152",
	"./mind_network.png": "e5c1",
	"./mind_network_normal.png": "f6ed",
	"./pado.svg": "bc8b",
	"./pado_hoverd.svg": "737a",
	"./permaweb_news.svg": "9f10",
	"./permaweb_news_normal.svg": "fefb",
	"./readon.png": "7c5c",
	"./readon_normal.png": "ffa5",
	"./revox.svg": "a6ad",
	"./revox_hoverd.svg": "cc40",
	"./s31.svg": "4477",
	"./s31_normal.svg": "1cb5",
	"./starpoweer.svg": "5774",
	"./starpoweer_nomal.svg": "2587"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ed22";